/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difference_Stat_MarketInputs */

const et_difference_stat_market = /** @type {(inputs: Difference_Stat_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turuosa`)
};

const en_difference_stat_market = /** @type {(inputs: Difference_Stat_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market share`)
};

/**
* | output |
* | --- |
* | "Market share" |
*
* @param {Difference_Stat_MarketInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const difference_stat_market = /** @type {((inputs?: Difference_Stat_MarketInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difference_Stat_MarketInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_difference_stat_market(inputs)
	return en_difference_stat_market(inputs)
});